export default {
  install(Vue) {
    Vue.prototype.$itemsSort = (items = [], firstField = 'name', secondField = null) => {
      if (Array.isArray(items) && items.length > 0) {
        let preparedItems = items.slice()
        if (preparedItems[0][firstField])
          preparedItems.sort((a, b) => {
            if (a[firstField] < b[firstField]) return -1
            if (a[firstField] > b[firstField]) return 1
            if (a[firstField] === b[firstField]) {
              if (secondField && preparedItems[0][secondField]) {
                if (a[secondField] < b[secondField]) return -1
                if (a[secondField] > b[secondField]) return 1
              }
              return 0
            }
          })
        return preparedItems
      }
      return items
    }
  },
}
